import Pocketracker from "../assets/pocketracker.png";
import Shishiram from "../assets/shishiram4.png";
import Portfolio from "../assets/portfolio.png";
import NovaFrame from "../assets/novaframe.png";
import Movieapp from "../assets/movieapp.png";
import Netflix from "../assets/netflix.png";
import YouTube from "../assets/youtube.png";
import Calc from "../assets/calculator.png";
import Qleads from "../assets/qleads.png";
import Seti from "../assets/seticss1.png";
import Whisplay from "../assets/whisplay.png";
import Helbeku from "../assets/helbeku.png";
import FlixClub from "../assets/flixclub.png";
import Cyber from "../assets/cyber.png";
import Sevana from "../assets/sevana.png";
import Space from "../assets/space.png";
import Soque from "../assets/soque.png";
import Bizco from "../assets/bizco.png";
import Shop from "../assets/shopsyi.png";
import Thulli from "../assets/thulli.png";
import Todo from "../assets/todo.png";
import Old from "../assets/old.png";
import Iiq from "../assets/iiq.png";

export const ProjectList = [
  {
    name: "FlixClub",
    image: FlixClub,
    skills:
      "Next.js, TMDB API, Episode Tracking, Tailwind, MongoDB, UI/UX Design",
    url: "https://flixclub.vercel.app",
    github: "https://github.com/silentCosmo/flixclub",
    description: `FlixClub is a complete media-tracking platform that unifies movies, series, and anime under one clean and simple interface. Users can track series episode-by-episode, maintain watchlists, and log completed films, series, and anime into a personal diary. Designed with a smooth, uncomplex UI, FlixClub delivers a unique experience that goes beyond simple discovery. it becomes your companion for everything you watch.`,
  },
  {
    name: "Whisplay",
    image: Whisplay,
    skills:
      "Next.js, PWA, Music Player, UI/UX Design, Audio Visualizers, Google Drive as CDN",
    url: "https://whisplay.vercel.app",
    github: "https://github.com/silentCosmo/whisplay",
    description: `Whisplay is a sleek and modern music streaming app featuring 10 dynamic audio visualizers, playlist, queue system, shuffle and repeat modes, and smooth UI transitions. Designed for an immersive and intuitive experience, Whisplay blends stunning visuals with seamless performance in a fully responsive PWA.`,
  },
  {
    name: "Quantum Leads",
    image: Qleads,
    skills: "Next.js, formSubmit",
    url: "https://quantumleads.in/",
    github: "https://github.com/integraliQ/leads",
    description: `Website for a advertising company.`,
  },
  {
    name: "IntegraliQ",
    image: Iiq,
    skills: "Next.js, React, MongoDB, App API Router Endpoints",
    url: "https://integraliq.in",
    github: "https://github.com/xsilentCosmo/iiq",
    description: `Website for a business incubation company.`,
  },
  {
    name: "Cyber Secqube",
    image: Cyber,
    skills: "Next.js, formSubmit",
    url: "https://cybersecqube.com/",
    github: "https://github.com/integraliQ/secqube",
    description: `Website for a Education institution.`,
  },
  {
    name: "BizConsult",
    image: Bizco,
    skills: "Next.js, formSubmit",
    url: "https://thebizconsultant.in",
    github: "https://github.com/integraliQ/bizconsult",
    description: `Website for a Business Consultancy.`,
  },
  {
    name: "iiQ Space",
    image: Space,
    skills:
      "Next.js, React, Payment Gateway Integration, Firebase auth, FirestoreDB",
    url: "https://iiqspace.com",
    github: "https://github.com/integraliQ/spaces",
    description: `Website for co-working space provider.`,
  },
  {
    name: "Thulli",
    image: Thulli,
    skills: "Next.js, AI Prompting, UI/UX Design, Realtime Processing",
    url: "https://thulli.vercel.app",
    github: "https://github.com/silentCosmo/thulli",
    description: `Thulli is a soft AI companion designed to respond with gentle, human-like behavior. Built to create a warm, emotional interaction experience rather than raw chatbot outputs, Thulli focuses on tone, personality, and subtle AI responses.`,
  },
  {
    name: "Youtube Clone",
    image: YouTube,
    skills: "Nodejs, React, Firebase Store, Backend, API Endpoints",
    url: "https://youtubewa.vercel.app",
    github: "https://github.com/silentCosmo/youtube",
    description: `It's a clone of youtube webapp with signup,channel creation, upload, delete, comment, edit and more.`,
  },
  {
    name: "Helbeku",
    image: Helbeku,
    skills: "Next.js, Realtime database, Analytics & SEO",
    url: "https://helbeku.vercel.app",
    github: "https://github.com/silentCosmo/helbeku",
    description: `Helbeku is a free and engaging platform for meeting new people through chats. Discover a fun way to connect with strangers`,
  },
  {
    name: "Sevana-mvp",
    image: Sevana,
    skills: "Next.js",
    url: "https://onlinesevana.com/",
    github: "https://github.com/integraliQ/csc",
    description: `CSC website front-end mvp`,
  },
  {
    name: "Soque-MVP",
    image: Soque,
    skills: "Next.js, Next Auth, Google Auth, MongoDB, NodeMailer",
    url: "https://soque.netlify.app",
    github: "https://github.com/silentCosmo/soque",
    description: `Social media management app (Paused project)`,
  },

  {
    name: "NovaFrame",
    image: NovaFrame,
    skills: "NextJS, React, Tailwind, AI Endpoints, Analytics & SEO",
    url: "https://novaframe.netlify.app",
    github: "https://github.com/silentCosmo/nova-frame",
    description: `NovaFrame is AI-Powered Image Generation Platform it is an advanced web application,
                    designed to leverage artificial intelligence for generating visually stunning and customizable images.
                    Whether you're an artist, designer, or enthusiast, NovaFrame provides a powerful toolkit to create captivating visuals effortlessly.`,
  },
  {
    name: "PockeTracker",
    image: Pocketracker,
    skills: "React, Redux, Draggable, Tailwind, LocalStorage",
    url: "https://pocketracker.netlify.app",
    github: "https://github.com/silentCosmo/pocketracker",
  },
  {
    name: "Blog App",
    image: Shishiram,
    skills:
      "React, Redux, Glassmorphism, Firebase, Google Auth, Realtime Database, Tailwind",
    url: "https://winternib.vercel.app",
    github: "https://github.com/silentCosmo/shishiram",
  },
  {
    name: "Shopsyi",
    image: Shop,
    skills: "React, Redux, Router, Tailwind CSS, Firebase, Firestore",
    url: "https://shopsyi.netlify.app/",
    github: "https://github.com/silentCosmo/shopsyi",
  },
  {
    name: "Netflix Clone",
    image: Netflix,
    skills: "JSX, CSS, API, ReactJS",
    url: "https://cosmoflix.netlify.app",
    github: "https://github.com/silentCosmo/netflix",
  },
  {
    name: "React Portfolio",
    image: Portfolio,
    skills: "Jsx, CSS, React Router",
    url: "https://silentcosmo.netlify.app",
    github: "https://github.com/silentcosmo/react-portfolio",
  },
  {
    name: "Movie Booking",
    image: Movieapp,
    skills: "React, Redux, API, Tailwind",
    url: "https://movieapp-testapi.netlify.app",
    gitHub: "https://github.com/silentCosmo/api-movie",
  },
  {
    name: "Todo App",
    image: Todo,
    skills: "JSX, CSS, React, Javascript",
    url: "http://todocosmo.netlify.app",
    github: "https://github.com/silentCosmo/todo",
  },
  {
    name: "Shoping Cart",
    image:
      "https://soshace.com/wp-content/uploads/2019/12/nodejs-architecture.jpg",
    skills: "NodeJs, MongoDB, Bootstrap, Handlebars, JSX, CSS ",
    url: "https://github.com/silentCosmo/Shopping-cart",
    github: "https://github.com/silentCosmo/Shopping-cart",
  },
  {
    name: "Responsive CSS",
    image: Seti,
    skills: "HTML, CSS",
    url: "https://silentcosmo.github.io/responsive-css",
    gitHub: "https://github.com/silentCosmo/responsive_css",
  },
  {
    name: "First Website",
    image: Old,
    skills: "HTML, CSS, Bootstrap, Javascript",
    url: "https://silentcosmo.github.io/personal-site",
    github: "https://github.com/silentCosmo/pSite",
  },
  {
    name: "Calculator",
    image: Calc,
    skills: "HTML, CSS, jQuery",
    url: "https://silentcosmo.github.io/Calculator/",
    gitHub: "https://github.com/silentCosmo/calculator",
  },
];
